import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./component_form_preview.module.scss";

interface IComponentFormPreviewProps {

}

export const ComponentFormPreview: React.FC<IComponentFormPreviewProps> = React.memo(() => {
    const t = useComponentsTranslations();

    return <div className={styles.container}>
        <div className={styles.description}>{t("previewComponentDescription")}</div>
    </div>;
});
